const keys = {
  Enter: 'Enter',
  Escape: 'Escape',
}

export const onKeyDownEventHandler = <T extends HTMLElement>(
  event: React.KeyboardEvent<T>,
  callback?: () => void,
): void => {
  switch (event.key) {
    case keys.Enter:
      event.preventDefault()
      callback?.()
      break
    case keys.Escape:
      event.preventDefault()
      callback?.()
      break
  }
}
